import { Box, Text, Grid, Flex } from "@chakra-ui/layout";
import {
  Button,
  Select,
  Radio,
  RadioGroup,
  Divider,
  useMediaQuery,
  Spinner,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import InspirationBoard3 from "../../../assets/InspirationBoardAssets/inspiDash.png";
import stars from "../../../assets/5StarsRatings/4stars.png";
import { Image } from "@chakra-ui/image";
import {
  getInspiration,
  fetchInspirationBoard,
  BASE_URL_WISHLIST,
} from "../../../Redux/App/action";
import { useDispatch, useSelector } from "react-redux";
// import { BsCart2 } from "react-icons/bs";
import { BsSearch } from "react-icons/bs";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import corp from "../../../assets/bannerInspiration/corporate.png";
import decor from "../../../assets/bannerInspiration/homedecor.png";
import pot from "../../../assets/bannerInspiration/pot.png";
import birthday from "../../../assets/bannerInspiration/birthday.png";
import mis from "../../../assets/bannerInspiration/mis.png";
import diwali from "../../../assets/bannerInspiration/diwali.png";
import sus from "../../../assets/bannerInspiration/sustainable.png";
import ani from "../../../assets/bannerInspiration/aniversary.png";
import wedding from "../../../assets/bannerInspiration/wedding.png";
import { useCallback } from "react";

const InspirationDash = () => {
  const dispatch = useDispatch();
  const { inspiration, filterInspiration, isLoading } = useSelector(
    (store) => store.appReducer
  );
  const param = useParams();
  const inspirationBoardCategory = param._id;

  const [showInspirationData, setShowInspirationData] = useState(false);
  const [isMediumScreen] = useMediaQuery("(min-width: 768px)");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [budget, setBudget] = useState("");
  const [filterDataAvailable, setFilterDataAvailable] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);
  const [isLoadingWishlist, setIsLoadingWishlist] = useState(false);
  const [showFilterForm, setShowFilterForm] = useState(false);
  const [catData, setCatData] = useState([]);
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(0);

  const itemsPerPage = 12;
  useEffect(() => {
    dispatch(getInspiration(currentPage, itemsPerPage));
  }, [dispatch, currentPage]);

  // To Fetch all Category
  useEffect(() => {
    axios
      .get(`${BASE_URL_WISHLIST}/category/getListCategory`)
      .then((response) => {
        setCatData(response.data.payload);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("event", inspirationBoardCategory);
    formData.append("gender", gender);
    formData.append("age", age);
    formData.append("budget", budget);
    setShowFilterForm(false);
    try {
      await dispatch(fetchInspirationBoard(formData));
      setFilterDataAvailable(true);
      setSearchClicked(true);
    } catch (error) {
      setIsLoadingWishlist(false);
      console.error("Error fetching data:", error);
    }
  };
  const totalPages = Math.ceil(inspiration.length / itemsPerPage);
  const [inspirationData, setInspirationData] = useState([]);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentData = inspiration.slice(startIndex, endIndex);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handlefilterby = () => {
    setShowFilterForm(true);
  };

  useEffect(() => {
    if (inspirationData && inspirationData.length > 0) {
      setShowInspirationData(true);
    }
  }, [inspirationData]);

  const getSearchData = useCallback(async () => {
    try {
      const response = await axios.get(
        `${BASE_URL_WISHLIST}/inspirationboard/getInspirationsByCategory?page=${currentPage}&size=10&category=${inspirationBoardCategory}`
      );

      if (response.status === 200) {
        if (response.data.payload.length === 0) {
          setShowInspirationData(false);
        }
        setInspirationData(response.data.payload);
      }
    } catch (e) {
      console.clear(e);
    }
  }, [currentPage, inspirationBoardCategory]);

  useEffect(() => {
    getSearchData();
  }, [getSearchData]);

  let imageName;

  switch (inspirationBoardCategory) {
    case "CORPORATE":
      imageName = corp;
      break;
    case "HOMEDECOR":
      imageName = decor;
      break;
    case "BIRTHDAY":
      imageName = birthday;
      break;
    case "WEDDING":
      imageName = wedding;
      break;
    case "SUSTAINABLE":
      imageName = sus;
      break;
    case "ANNIVERSARY":
      imageName = ani;
      break;
    case "INVITATIONS":
      imageName = mis;
      break;
    case "DIWALI":
      imageName = diwali;
      break;
    default:
      imageName = pot;
      break;
  }
  const Loader = () => {
    return (
      <Box
        position="fixed"
        top="0"
        left="0"
        width="100%"
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        background="rgba(0, 0, 0, 0.5)"
        zIndex="9999"
      >
        <Spinner size="xl" color="blue.500" thickness="4px" />
      </Box>
    );
  };
  if (isLoading) {
    return (
      <Box h={"80vh"}>
        <Loader />
      </Box>
    );
  }

  return (
    <Box>
      {/* top banner */}
      <Box>
        {/* Image Boxes on banner */}
        <Box>
          <Image
            src={imageName}
            alt="Inspiration Board"
            w={{ base: "100%", md: "98%" }}
            m={"auto"}
          />
          <Text
            width="100%"
            margin={"auto"}
            fontFamily="Oswald"
            fontWeight="bold"
            fontSize={{ base: "10px", md: "16px" }}
            color="black"
            textAlign="center"
            textTransform="capitalize"
            opacity="1"
          >
            Your total point is{" "}
            <span
              style={{
                fontFamily: "Lato",
                fontSize: "semibold",
                color: "#9554DF",
              }}
            >
              3000 pts
            </span>
          </Text>
        </Box>
      </Box>

      <Box
        w={"80%"}
        margin={"auto"}
        p={"2"}
        fontWeight={"bold"}
        fontSize={"10px"}
      >
        <Text>
          Anniversaries are milestones worth celebrating, and our Inspiration
          Boards are here to help you find the ideal gift to express your love
          and appreciation. From romantic getaways to custom jewelry and
          heartfelt photo albums, your thoughtful gesture will make their day
          even more memorable. No matter the occasion, Wishfy's Inspiration
          Boards are your go-to resource for finding the perfect gift that
          speaks volumes. Browse our carefully curated collections to discover
          unique, thoughtful, and meaningful presents that will leave a lasting
          impression. Make gifting an art with Wishfy!
        </Text>
      </Box>
      <Box>
        <Flex flexDirection={{ base: "column", md: "row" }}>
          <Box w={{ base: "100%", md: "25%" }}>
            {/* Filter Section */}
            <form onSubmit={handleSubmit}>
              <Box mb={"10"} w={"100%"}>
                <Flex
                  p={1}
                  gap={5}
                  w={{ base: "100%", md: "75%" }}
                  m="auto"
                  mt={2}
                  flexDirection={{ md: "column", base: "column" }}
                  justifyContent="center"
                >
                  {/* Event Select */}
                  <Box w={"100%"}>
                    <Flex flexDirection={"row"}>
                      <Text
                        fontWeight={"bold"}
                        fontSize={"10px"}
                        mt={"2"}
                        mb={1}
                      >
                        Category Type:
                      </Text>
                      <Select
                        border="1px solid gray"
                        w="60%"
                        h="4"
                        fontSize={"10px"}
                        name="event"
                        value={inspirationBoardCategory}
                        onChange={(inspirationCategory) => {
                          setCurrentPage(0);
                          navigate(
                            `/inspirationDashboard/${inspirationCategory.target.value}`
                          );
                        }}
                        textAlign="left"
                        fontWeight="bold"
                        margin="auto"
                      >
                        <option value="">Select Category</option>
                        {catData &&
                          catData.map((el, i) => (
                            <option value={el.categoryName} key={i}>
                              {el.categoryName}
                            </option>
                          ))}
                      </Select>
                    </Flex>
                  </Box>
                </Flex>
              </Box>
            </form>
          </Box>

          {isMediumScreen && (
            <Divider
              orientation="vertical"
              border="2px solid gray"
              h={"100%"}
              mr="10"
              mt="5"
            />
          )}
          {/* Products */}
          <Box w={"80%"} h={"100%"} margin={"auto"}>
            <Grid
              templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(3, 1fr)" }}
              gap={10}
            >
              {(filterInspiration ? filterInspiration : inspiration).map(
                (item, index) => (
                  <Box
                    key={index}
                    h="100%"
                    margin="auto"
                    w="100%"
                    overflow="hidden"
                    mb="4"
                  >
                    <Box>
                      <Image
                        borderRadius={"5"}
                        src={item.imgUrl}
                        alt={`Product ${item.product}`}
                        h="200"
                        w="100"
                        margin="auto"
                        objectFit="cover"
                      />
                    </Box>
                    <Box w={"88%"} margin="auto">
                      <Text
                        fontSize="12px"
                        fontWeight="bold"
                        textAlign="left"
                        fontFamily="sans-serif"
                      >
                        Event: {item.event}
                      </Text>
                      <Text
                        fontSize="12px"
                        fontWeight="bold"
                        textAlign="left"
                        fontFamily="sans-serif"
                      >
                        Name: {item.product}
                      </Text>
                      <Text
                        fontSize="12px"
                        fontWeight="bold"
                        textAlign="left"
                        fontFamily="sans-serif"
                      >
                        Gender: {item.gender}
                      </Text>

                      <Text
                        fontSize="12px"
                        fontWeight="bold"
                        textAlign="left"
                        fontFamily="sans-serif"
                      >
                        Ranging From ₹{item.priceStartRange} to ₹
                        {item.priceEndRange}
                      </Text>

                      <Flex
                        gap={10}
                        alignItems="center"
                        justifyContent="space-between"
                        pr={5}
                      >
                        <Box>
                          <Flex gap={5} justifyContent="space-evenly">
                            <Text
                              color="#787A79"
                              fontWeight="bold"
                              fontSize={10}
                            >
                              Starting From
                            </Text>
                            <Text
                              color="grey"
                              fontWeight="bold"
                              fontSize={10}
                              textDecoration="line-through"
                            >
                              ₹{item.priceStartRange}
                            </Text>
                            <Text
                              color="#395D00"
                              fontWeight="bold"
                              fontSize={10}
                            >
                              ₹{item.priceEndRange}
                            </Text>
                          </Flex>
                        </Box>
                        {/* <Box>
                          <Box
                            bg="#E5E5E5"
                            w={8}
                            p={1}
                            pl="6px"
                            borderRadius={50}
                          >
                            <BsCart2 size={15} />
                          </Box>
                        </Box> */}
                      </Flex>
                    </Box>
                  </Box>
                )
              )}
              {showInspirationData
                ? inspirationData.map((item) => (
                    <Link
                      to={`https://${item.inspirationBoardUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Box
                        key={item.id}
                        h="100%"
                        margin="auto"
                        w="100%"
                        overflow="hidden"
                        mb="4"
                      >
                        <Box>
                          <Image
                            borderRadius={"5"}
                            src={item.imgUrl}
                            alt={`Product ${item.id}`}
                            h="200"
                            w="100"
                            margin="auto"
                            objectFit="cover"
                          />
                        </Box>
                        <Box w={"88%"} margin="auto">
                          <Text
                            fontSize="12px"
                            fontWeight="bold"
                            textAlign="left"
                            fontFamily="sans-serif"
                          >
                            Name: {item.product}
                          </Text>
                          <Text
                            fontSize="12px"
                            fontWeight="bold"
                            textAlign="left"
                            fontFamily="sans-serif"
                          >
                            Ranging From ₹{item.priceStartRange} to ₹
                            {item.priceEndRange}
                          </Text>

                          <Flex
                            gap={10}
                            alignItems="center"
                            justifyContent="space-between"
                            pr={5}
                          >
                            {/* <Box>
                              <Box
                                bg="#E5E5E5"
                                w={8}
                                p={1}
                                pl="6px"
                                borderRadius={50}
                              >
                                <BsCart2 size={15} />
                              </Box>
                            </Box> */}
                          </Flex>
                        </Box>
                      </Box>
                    </Link>
                  ))
                : inspiration.map((item) => (
                    <Link
                      to={`https://${item.inspirationBoardUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Box
                        key={item.id}
                        h="100%"
                        margin="auto"
                        w="100%"
                        overflow="hidden"
                        mb="4"
                      >
                        <Box>
                          <Image
                            borderRadius={"5"}
                            src={item.imgUrl}
                            alt={`Product ${item.id}`}
                            h="200"
                            w="100"
                            margin="auto"
                            objectFit="cover"
                          />
                        </Box>
                        <Box w={"88%"} margin="auto">
                          <Text
                            fontSize="12px"
                            fontWeight="bold"
                            textAlign="left"
                            fontFamily="sans-serif"
                          >
                            Name: {item.product}
                          </Text>

                          <Text
                            fontSize="12px"
                            fontWeight="bold"
                            textAlign="left"
                            fontFamily="sans-serif"
                          >
                            Ranging From ₹{item.priceStartRange} to ₹
                            {item.priceEndRange}
                          </Text>

                          <Flex
                            gap={10}
                            alignItems="center"
                            justifyContent="space-between"
                            pr={5}
                          >
                            {/* <Box>
                              <Box
                                bg="#E5E5E5"
                                w={8}
                                p={1}
                                pl="6px"
                                borderRadius={50}
                              >
                                <BsCart2 size={15} />
                              </Box>
                            </Box> */}
                          </Flex>
                        </Box>
                      </Box>
                    </Link>
                  ))}
            </Grid>

            {/* Pagination Button */}
            {showInspirationData ? (
              <Flex justifyContent="center" mt="4">
                <Box>
                  <Button
                    textAlign="left"
                    fontFamily="sans-serif"
                    fontWeight="normal"
                    fontSize="16px"
                    lineHeight="19px"
                    letterSpacing="0px"
                    bgColor="#6FADDC"
                    opacity="1"
                    onClick={() => setCurrentPage(currentPage - 1)}
                    isDisabled={currentPage <= 0}
                  >
                    Prev
                  </Button>
                </Box>
                {Array.from({ length: totalPages }).map((_, index) => (
                  <Box key={index} mx="2" mb={"5"}>
                    <Button
                      bg={"#6FADDC"}
                      fontWeight={"bold"}
                      // onClick={() => handlePageChange(index + 1)}
                      onClick={() => setCurrentPage(currentPage + 1)}
                      // style={{
                      //   fontWeight: currentPage === index + 1 ? "bold" : "normal",
                      //   background:
                      //     currentPage === index + 1 ? "#" : "white",
                      // }}
                      color={"white"}
                      rounded={"20px"}
                    >
                      {currentPage + 1}
                    </Button>
                  </Box>
                ))}
                <Box>
                  <Button
                    textAlign="left"
                    fontFamily="sans-serif"
                    fontWeight="normal"
                    fontSize="16px"
                    lineHeight="19px"
                    letterSpacing="0px"
                    bgColor="#6FADDC"
                    opacity="1"
                    // onClick={() => handlePageChange(currentPage + 1)}
                    onClick={() => setCurrentPage(currentPage + 1)}
                    isDisabled={inspirationData.length < 10}
                  >
                    Next
                  </Button>
                </Box>
              </Flex>
            ) : (
              <></>
            )}
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};

export default InspirationDash;
